export const WORDLIST_SORTED = 'wordlistsSorted'
export const WORDLIST_BY_ID = 'wordlistById'
